import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 py-4 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Desktop Layout - Same as Mobile */}
        <div className="hidden sm:flex flex-col items-center justify-center gap-2 text-sm text-gray-600 dark:text-gray-400 text-center">
          {/* Privacy Notice - First Line */}
          <p className="text-xs">
            {t('footer.dataPrivacy')}
          </p>
          
          {/* Copyright + Rights Reserved - Second Line */}
          <span className="text-xs">
            © {currentYear} {t('footer.companyName')} {t('footer.allRightsReserved')}
          </span>

          <a
            href="https://www.mygnest.com"
            target="_blank"
            rel="noreferrer"
            className="text-xs text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
          >
            www.mygnest.com
          </a>
        </div>

        {/* Mobile Layout - Vertical */}
        <div className="flex sm:hidden flex-col items-center justify-center gap-2 text-sm text-gray-600 dark:text-gray-400 text-center">
          {/* Privacy Notice - First Line */}
          <p className="text-xs">
            {t('footer.dataPrivacy')}
          </p>
          
          {/* Copyright + Rights Reserved - Second Line */}
          <span className="text-xs">
            © {currentYear} {t('footer.companyName')} {t('footer.allRightsReserved')}
          </span>

          <a
            href="https://www.mygnest.com"
            target="_blank"
            rel="noreferrer"
            className="text-xs text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
          >
            www.mygnest.com
          </a>
        </div>
      </div>
    </footer>
  );
}
